import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setIsMulti: YJSChangeHandler<DatabaseChangeType.SET_IS_MULTI> = ({
  ydb,
  change,
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.multi = change.isMulti;
  });
};
